<template>
<v-ons-page>
        <ons-toolbar class="main-toolbar" >

        </ons-toolbar>

        <div class="content">

            <div class="content-inner">
                <div class="main-header">Not found</div>

                <p>Sorry, we couldn't find that page.</p>

                <section class="section-vh">
                    <gtc-button v-on:click="$router.replace({ name: 'Outlets' })" class="btn-action"
                                data-test-id="href-home">
                        Go to home page
                    </gtc-button>
                </section>

            </div>

        </div>

    </v-ons-page>
</template>

<script>


    export default {

        created() {

        },

        mounted() {

        },

        data () {
            return {

            }
        },
    }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/js/components/notfound.vue